
import { getNotifications } from "../../utils/services/notification/notificationService";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchNotification = createAsyncThunk(
  "/admin/getNotification",
  async (params, thunkAPI) => {
      const {page,limit}=params;
    const { data, error } = await getNotifications({page,limit});
    if (error) {
        console.log("ERRRRRR:", error);
        return thunkAPI.rejectWithValue(response?.error);
    }
    console.log("PAYLAODDDDD:::", data);
    return data;
  }
);

const initialState = {
  notificationData: null,
  error: null,
  loading: false,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchNotification.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchNotification.fulfilled, (state, action) => {
      state.loading = false;
      state.notificationData = action?.payload;
    });
    builder.addCase(fetchNotification.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export default notificationSlice.reducer;
